import React from 'react';
import { Helmet } from 'react-helmet';
import { DOMAIN } from '../../../config';

const MetaDecorator = ({ title, description, imgSrc }) => {
  // Ensure image URL is absolute
  const imageUrl = imgSrc && imgSrc.startsWith('http') 
    ? imgSrc 
    : `${DOMAIN}${imgSrc && imgSrc.startsWith('/') ? imgSrc : '/' + (imgSrc || 'fb-meta-home.jpg')}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      <meta name="description" content={description} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:url" content={DOMAIN} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="बड़ेला धाम भारतवर्ष" />
    </Helmet>
  );
};

export default MetaDecorator;



// WEBPACK FOOTER //
// ./src/components/common/loader/metaDecorator.jsx